import useStaffProfileStore from '../../../stores/staffProfileStore';

const StaffHeaderActions = () => {
	const { profile } = useStaffProfileStore();

	const firstName = profile?.firstName || '';
	const lastName = profile?.lastName || '';
	const name = [firstName, lastName].filter(Boolean).join(' ');
	const staffType = profile?.staffTypeName || '';

	// Generate initials from name (e.g., "Sarah Johnson" → "SJ")
	const initials = [firstName, lastName]
		.filter(Boolean)
		.map(part => part.charAt(0))
		.join('')
		.toUpperCase();

	return (
		<div className="flex items-center gap-3 md:gap-4 flex-shrink-0">
			<div className="text-right hidden md:block">
				<div className="font-bold text-base">{name}</div>
				{staffType && <div className="text-xs opacity-80">{staffType}</div>}
			</div>
			<div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold border-2 border-white/30">
				{initials || '?'}
			</div>
		</div>
	);
};

export default StaffHeaderActions;
